<template>
	<div class="z-[10] mp-bottompc">
		<!-- PC 底部版权 / 社群 / 币种 / 博彩责任模块已按需求隐藏
		<div class="pb-[70px]">
			<div class="flex flex-col lg:flex-row pt-[10px] lg:pt-[30px] pb-[30px] justify-center text-white">
				<div class="flex flex-col items-center" style="flex:1">
					<div class="w-[calc(100%-40px)] lg:w-[289px] flex-col flex justify-center items-center"><img
							data-nuxt-img=""
							class="ml-[-10px] w-[150px] lg:w-[289px] lg:h-[90px]" src="@/assets/newimg/wgclub_logo.webp">
						<div class="text-[12px] font-normal tracking-[2px] text-[#9D9D9D] leading-[18px] pt-[10px]">
							WGCLUB 由 W&C N.V. 持有和運營，該公司在庫拉索註冊，公司編號 145637，註冊地址：Groot Kwartierweg 10, Livestrong Building。W&C N.V. 受庫拉索博彩管理委員會（GCB）許可和監管，許可證編號 OGL/2024/922/0638。該許可證由庫拉索政府頒發並監管，確保平台的合法性、安全性與合規性。WGCLUB 致力於為所有用戶提供安全、可靠、公平的遊戲環境。無論是下註、玩老虎機，還是參與真人或其他遊戲活動，您都可以放心，WGCLUB 堅持誠信運營，為每位玩家提供卓越的遊戲體驗。
						</div>
					</div>
				</div>
				
				<div class="flex justify-center flex-col px-[20px] pt-[20px]" style="flex:0.6">
					<div>
						<div class="min-h-[90px] lg:block flex flex-col items-center">
							<div class="text-white $-font-[600] text-[16px] ms:text-center lg:!text-start">社群入口</div>
							<div class="flex gap-[10px] pt-[10px]">
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="@/assets/newimg/home/facebook.webp"  srcset="@/assets/newimg/home/facebook.webp 1x, @/assets/newimg/home/facebook.webp 2x" class="size-[40px]" src="@/assets/newimg/home/facebook.webp" />
								</div>
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="@/assets/newimg/home/instagram.webp"  srcset="@/assets/newimg/home/instagram.webp 1x, @/assets/newimg/home/instagram.webp 2x" class="size-[40px]" src="@/assets/newimg/home/instagram.webp" />
								</div>
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="@/assets/newimg/home/youtube.webp"  srcset="@/assets/newimg/home/youtube.webp 1x, @/assets/newimg/home/youtube.webp 2x" class="size-[40px]" src="@/assets/newimg/home/youtube.webp" />
								</div>
								
							</div>
						</div>
					</div>
					<div class="py-[10px]">
						<div class="min-h-[90px] lg:block flex flex-col items-center">
							<div class="text-white $-font-[600] text-[16px] ms:text-center lg:!text-start">支持的币种</div>
							<div class="flex pt-[10px] gap-[10px]">
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="USDT"  class="size-[40px]" src="@/assets/newimg/home/USDT.webp" />
								</div>
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="ALIPAY"   class="size-[40px]" src="@/assets/newimg/home/ALIPAY.webp" />
								</div>
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="FPS"   class="size-[40px]" src="@/assets/newimg/home/FPS.webp" />
								</div>
								<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
								 <img alt="BTC"   class="size-[40px]" src="@/assets/newimg/home/BTC.webp" />
								</div>
							</div>
						</div>
					</div>
					<div class="$-font-[600] text-[16px] ms:text-center lg:!text-start pb-[5px]">赞助和博彩责任</div>
					<div class="text-[#a6b2c0] text-[12px] cursor-pointer">
					 <img alt="@/assets/newimg/home/gambling_v4.webp"  srcset="@/assets/newimg/home/gambling_v4.webp 1x, @/assets/newimg/home/gambling_v4.webp 2x" class="size-[40px]" src="@/assets/newimg/home/gambling_v4.webp" />
					</div>
				</div>
			</div>
		</div>
		-->
	</div>
</template>

<script>
	import {
		eventBus
	} from '@/App.vue'
	import {
		getsystemconfig,
	} from "../utils/api.js";
	export default {
		props: {
			isSelNav: Number
		},
		data() {
			return {
				img: {
					x: 40,
					y: 60
				},
				isDragging: false,
				offsetX: 0,
				offsetY: 0,
				dragMask: null,
				systemconfig: {},
				isLoadingShow: false,
				kefushow: false,
				url: ""
			}
		},
		created() {},
		mounted() {
			this.getSystemconfig()
			window.location.href.indexOf("?show") > -1 ? this.isLoadingShow = true : ''
		},
		methods: {
			toggleLeft() {
				// 触发事件总线的「toggleLeft」事件
				eventBus.$emit('toggleLeft')
			},
			getEventClientXY(e) {
				if (e.type.startsWith('touch')) {
					// touch 事件：e.touches[0]
					const touch = e.touches[0] || e.changedTouches[0];
					return {
						x: touch.clientX,
						y: touch.clientY
					};
				} else {
					// mouse 事件
					return {
						x: e.clientX,
						y: e.clientY
					};
				}
			},

			startDrag(e) {
				const imgRect = e.target.getBoundingClientRect();
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				this.isDragging = true;
				this.offsetX = clientX - imgRect.left;
				this.offsetY = clientY - imgRect.top;
				if (!this.dragMask) {
					this.dragMask = document.createElement('div');
					this.dragMask.style.cssText = `
			        position: fixed;
			        top: 0; left: 0;
			        width: 100vw; height: 100vh;
			        z-index: 99998;
			        pointer-events: none;
			      `;
					document.body.appendChild(this.dragMask);
				}
				document.addEventListener('mousemove', this.onDragMove);
				document.addEventListener('touchmove', this.onDragMove, {
					passive: false
				});
				document.addEventListener('mouseup', this.stopDrag);
				document.addEventListener('touchend', this.stopDrag);
			},
			tiyu() {
				this.url = 'https://www.baidu.com'
			},
			onDragMove(e) {
				if (!this.isDragging) return;
				e.preventDefault(); // 阻止页面滚动
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				const containerRect = this.$refs.container.getBoundingClientRect();

				let newX = clientX - this.offsetX;
				let newY = clientY - this.offsetY;

				newX = Math.max(0, Math.min(newX, containerRect.width - 40));
				newY = Math.max(0, Math.min(newY, containerRect.height - 40));

				this.img.x = newX;
				this.img.y = newY;
			},

			stopDrag() {
				this.isDragging = false;
				document.removeEventListener('mousemove', this.onDragMove);
				document.removeEventListener('touchmove', this.onDragMove);
				document.removeEventListener('mouseup', this.stopDrag);
				document.removeEventListener('touchend', this.stopDrag);

				if (this.dragMask) {
					document.body.removeChild(this.dragMask);
					this.dragMask = null;
				}
			},
			closeGuanbi() {
				this.kefushow = false;
			},
			goNextPage(page, num) {
				// || !localStorage.getItem('token') && num == 3
				if (!localStorage.getItem('token') && num == 4) {
					this.$router.push('/login')
					return false;
				}
				if (num == 3) {
					this.kefushow = true;
					this.getSystemconfig();
					return false;
				}
				if (this.isSelNav != num) {
					this.$router.push(page)
				}
			},
			getSystemconfig() {

				this.isLoadingShow = true
				// setTimeout(() => {
				// 	wyWindow = window.open(location.href + '?show=1', "_blank");
				// }, 100);
				this.systemconfig = {};
				getsystemconfig()
					.then((res) => {

						if (res.status.errorCode == 0) {
							this.systemconfig = res.data;
							// wyWindow.location = this.systemconfig.service_link;
							// setTimeout(() => {
							// 	this.isLoadingShow = false;
							// }, 2000);
						} else {
							// this.$message.error(res.status.msg);
							this.$message({
								showClose: true,
								message: res.status.msg,
								type: "error",
							});
						}
					})
					.catch((err) => {
						console.log(err, "err");
					});
			},
			kefu(type) {
				var wyWindow = "";

				if (type == 1) {
					this.url = this.systemconfig.service_link;
				} else {
					wyWindow = window.open(location.href + '?show=1', "_blank");
					wyWindow.location = this.systemconfig.service_link2;
				}
			}
		}
	}
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.mp-bottompc {
		width: 100%;
		background: #000 !important;
		background-color: #000 !important;
		min-height: 24px;
	}

	.menu-block {
		width: 100%;
		position: fixed;
		bottom: 0;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #202020;
		border-radius: 20px 20px 0 0;
		box-shadow: 0 -2px 10px rgba(65, 70, 92, .2);
		gap: 6px;
		height: calc(50px + env(safe-area-inset-bottom));
		min-height: 50px;
		padding-bottom: env(safe-area-inset-bottom);
	}

	.mbitem {
		width: 25%;
		/* width: 20%; */
		text-align: center;
		color: rgba(255, 255, 255, .5);
		font-size: 12px;
		font-weight: 300;
		text-transform: capitalize;
		white-space: nowrap;
	}

	.mbitem:first-child img {
		width: 20px;
		height: 20px;
	}

	.mbitem:nth-child(2) img {
		width: 24px;
		height: 24px;
	}

	.mbitem:nth-child(3) img {
		width: 20px;
		height: 20px;
	}

	.mbitem:nth-child(4) img {
		width: 20px;
		height: 20px;
	}

	.mbitem:nth-child(5) img {
		width: 25px;
		height: 25px;
	}

	.dsfdasf {
		position: fixed;
		width: 100vw;
		height: 100vh;
		z-index: 999;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		background-color: rgba(77, 77, 77, 0.5);
	}

	.loading-medium {
		padding: 10px;
		box-sizing: border-box;
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 99999;
		width: 350px;
		height: 180px;
		border-radius: 5px;
		background-color: rgba(77, 77, 77, 1);
		transform: translate(-50%, -50%);
	}

	.loading-medium img {
		/* width: 28px; */
		height: 28px;
		/* margin-bottom: 3px; */
	}

	.sadasImg {
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		padding-bottom: 15px;
		border-bottom: 1px solid #ccc;
		color: #fff;
	}

	.dfsf {
		word-wrap: break-word;
		text-align: center;
		font-size: 16px;
		color: #fff;
		margin-top: 25px;
	}

	.dfsf img {
		vertical-align: middle;

	}

	.loading-medium.loading-small {
		width: 25px;
		height: 25px;
	}

	.loading-medium span {
		position: absolute;
		width: 5px;
		height: 5px;
		background-color: #efefef;
		border-radius: 50%;
		animation: load 1s linear infinite;
	}

	.wrapper {
		position: fixed;
		width: 100%;
		min-height: 100%;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 999999;
		background: #000;
	}

	iframe {
		width: 100%;
		height: 100%;
		border: 0;
	}

	.draggable-img {
		pointer-events: auto;
		/* 防止文字选中 */
		-webkit-user-drag: none;
		-khtml-user-drag: none;
		-moz-user-drag: none;
		-o-user-drag: none;
		user-drag: none;
	}

	.drag-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
		pointer-events: none;
		/* 👈 关键：容器不拦截事件 */
	}

	.drag-container img {
		pointer-events: auto;
		/* 👈 图片可以响应事件 */
	}
</style>